const brandEn = {
  brand: {
    添加品牌WhatsApp了解最新优惠:
      'Add brand <img src="https://ricepon.oss-cn-hongkong.aliyuncs.com//h5/172620942457196c293beRicepon.png" /> on WhatsApp to learn about the latest promotions',
    前往添加: "Go to add",
    更换地址: "Change address",
    自取: "Self pick up",
    外送: "Take Away",
    会员二维码: "QR code",
    优惠券: "Coupon({X})",
    邀请有礼: "Invitation",
    积分换礼: "Points",
    此等级需购买: "This level requires purchase",
    会员卡说明: "Membership Card Description",
    当前等级: "Current level",
    立即购买XY: "Buy Now {X}({Y})",
    查看等级特权: "View Level Privileges",
    暂不支持购买: "Not available for purchase yet!",
    查看更多: "View More",
    折扣优惠: "Discount Offer",
    零售价: "Retail Price",
    团购促销: "Group Buy Promo",
    人气王: "Popular Choice",
    回头客X: "Repeat Customer {X}",
    半年售X: "Sold {X} in 6 months",
    团购详情: "Group Buy Details",
    购买须知: "Purchase Notes",
    立即抢购: "Buy Now",
    请选择数量: "Please Select Quantity",
    免预约: "No Reservation Needed",
    周一到周日可用: "Available Mon-Sun",
    支付方式: "Payment Method",
    商品总价: "Total Price",
    优惠共减: "Total Discount",
    提交订单: "Submit Order",
    X人餐: "{X} Person Meal",
    提交成功: "Submitted Successfully!",
    品牌门店: "Brand Stores",
    壽司海鮮: "Sushi/Seafood",
    人均X: "{X}/person",
    查看更多店铺X: "View More Stores ({X})",
    分享至: "Share to",
    取消: "Cancel",
    Facebook: "Facebook",
    Instagram: "Instagram",
    WhatsApp: "WhatsApp",
    复制链接: "Copy Link",
    链接已复制: "Link Copied",
    复制失败: "Copy Failed",
    累计售X: "Sold {X}",
    抢购: "Buy",
    AI评分描述: "The rating is comprehensively calculated by AI by referencing third-party platform ratings for this restaurant. Ricepon is not responsible for this result. Please choose carefully~",
    餐厅类型X: "{X}",
    人均X: "{X}/person",
    营业时间: "Business hours",
    距您Xm: "{X} from you",
    导航: "Navigation",
    电话: "Phone",
    外送: "Delivery",
    自取: "Pick up",
    标签X: "Tab {X}",
    团购标题: "# Group Buy",
    餐厅简介: "Restaurant Profile",
    营业中: "Open",
    休息中: "Closed",
    繁忙中: "Busy",
    服务未开启: "Service Unavailable",
    memberCode: "Member Code",
    points: "Points",
    pointsAction: "Redeem Gifts, View Details",
    coupon: "Coupon",
    couponCount: "{X}",
    viewCollectedCoupons: "View collected coupons",
    noMore: "No more",
    團購券: "Group-buy voucher",
    餐飲券: "Dining voucher",
    storeAddressPlaceholder: "Please enter store address",
    opening: "Open",
    restaurantAddressUnset: "Restaurant address not set",
    placeOrder: "Order",
    distanceMeter: "Distance {X}m",
    chooseStoreByType: "Choose {X} Store",
    delivery: "Delivery",
    pickup: "Pick up",
    promoZone: "Promotion Zone",
    platformNotAvailable: "This platform is not available yet",
    soldOut: "Sold Out",
    onlinePayment: "Online Payment",
    noOpenRestaurantOrderTip:
      "No restaurants are currently open!\nPlease place your order later~!",
    invalidPrice: "Invalid price, please do not place the order!",
  },
};
export default brandEn;
